import DataGrid, {Column, FilterRow, LoadPanel, Paging, Scrolling} from "devextreme-react/data-grid";
import {LoadPagePanel} from "../../../../components";
import {useGetResourceGuides} from "../api/get-resource-guides";
import { useAddUserAccessLog } from "../api/add-user-access-log";
import { showErrorMessage } from "../../../../utils/messages";

export default function RecourceGuideGrid() {

	const resourceGuides = useGetResourceGuides();

	const addUserAccessLog = useAddUserAccessLog(
		() => { },
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<DataGrid
				className={'dx-card recource-guide-grid'}
				dataSource={resourceGuides.data}
				showBorders={true}
				showColumnLines={true}
				columnAutoWidth={true}
				width="40vw"
				height="68vh"
				keyExpr={'resourceGuideID'}
			>
				<LoadPanel enabled={false} />
				<Paging enabled={false}></Paging>
				<Scrolling rowRenderingMode='virtual'></Scrolling>
				<FilterRow visible={true} />

				<Column
					caption="Resource Guide"
					dataField={'resourceGuideName'}
					dataType="string"
					cellRender={(row) => {
						const handleClick = (e: any) => {
							e.stopPropagation();
							addUserAccessLog.mutate({ documentID: undefined, resourceGuideID: row.data.resourceGuideID});
						};

						return <a href={(!row.data.url.startsWith("http") ? "http://" : "") + row.data.url} target="_blank" rel="noreferrer" onClick={handleClick}>
							{row.data.resourceGuideName}
						</a>
					}}
				/>
			</DataGrid>
			<LoadPagePanel visible={resourceGuides.isLoading} />
		</>
	);
}
